import Draft from '.';
import { RouteType } from '@/lib/route';

const DraftRoutes: RouteType = {
  path: '/draft/:elearningId/:frameId?',
  component: Draft,
};

export default DraftRoutes;
